import BaseService from '../../base/base_service';
import HybridFactory from './hybrid_factory';
import {SYSTEM_EVENTS} from '../../events/events';
import {SERIVCES_PARAMS_LIST, SERIVCES_FUNC_LIST, KEY_NAME, LOCAL_HOST, OPEN_SETTINGS} from './native/native_const';
import DOM from '../../utils/dom';
import Device from '../../utils/device/device';
import Loader from '../../utils/module_loader';
import _ from '../../utils/underscore';
import {WEB_VIEW_IDS, WEB_VIEW_INFO} from "./features/web_view_manager/web_view_manager_consts";
import Event from "../../utils/event";
import {WaitForHybridGameStepLogicHandler} from "./wait-for-hybrid-game-step-logic-handler";



const ON_DEMAND_PORT = 8092;

/**
 * The hybrid service initialise the correct hybrid(IOS,Android)
 * The service send messages to the hybrid.
 * The service receive messages from the hybrid - by promise
 *
 *
 */
class HybridService extends BaseService {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'HybridService';

    /**
     * @property
     * @type {class}
     * @private
     */
    _wrapper = null;
    _threedtouchfeature = null;
    _touchidfeature=null;
    _fabricfeature=null;
    _pushfeature=null;
    _ondemandfeature=null;
    _ondemandnyxfeature=null;
    _webviewmanagerfeature=null;
    _hybridinfofeature=null;
    _lexisnexisfeature=null;
    _depositwidgetfeature=null;
    _appflayerfeature=null;
    _firebasefeature=null;
    _bDisplayWebView=false;
    _allCompiledGamesMetadata = {};
    _nLocalHostPort=-1;
    _strSmartLinkData=null;




    /**
     *
     * @param params
     */
    init(params) {
        super.init(params);

        if (Device.hybrid.isHybrid) {
            this._initWrapper();
            this._initFeatures(params);
            this._subscribe();
        }

        if (Device.hybrid.isEmbedded) {
            this._updateHybridCompiledGames();
        }
    }


    _subscribe() {
        this.onSystemEvent(SYSTEM_EVENTS.ON_INIT_COMPLETE, this.initHybrid);
        this.onSystemEvent(SYSTEM_EVENTS.APP_RESUMED, this.onDisplayWebView);
        this.onSystemEvent(SYSTEM_EVENTS.HYBRID_ALERT, this.alert);
        this.onSystemEvent(SYSTEM_EVENTS.HYBRID_OPEN_MAIL, this.openMail);
        this.onSystemEvent(SYSTEM_EVENTS.CLOSE_GAME, this._closeGame);
        this.onSystemEvent(SYSTEM_EVENTS.LOADING_INDICATOR_EMBEDDED_CLOSED_BY_X, this._onStopProgressBar);
    }

    runAutologin(tokenParams) {
        this.serviceFactory.queryStringDetectorService().tokenHandler(tokenParams);
    }

    getThreeDTouchFeature() {
        return this._threedtouchfeature;
    }
    getTouchIDFeaturer() {
        return this._touchidfeature;
    }

    getPushFeature() {
        return this._pushfeature;
    }

    getOnDemandTimeOut() {
        return this._ondemandfeature ? this._ondemandfeature.getTimeOut() : 0;
    }

    /**
     * The parames can be stored on window support (for poker...)
     */
    _updateHybridCompiledGames(){
        let gamesMetadata = window['hybridCompiledGamesMetadata'];

        if(gamesMetadata !== undefined && 'object' === typeof(gamesMetadata)){
            let port = window['hybridLocalPort'];
            this.setCompiledGamesMetadata(gamesMetadata, port);
        }
    }

    /**
     * The games stored in map"
     */

    setCompiledGamesMetadata(gamesMetadata, port) {
        this._allCompiledGamesMetadata = gamesMetadata;

        if (port) {
            this._nLocalHostPort = port;
        }
    }

    isGameApproved(gameType){
        return !this.isHybridSuportHtmlCompiledGames() || (this.isHybridSuportHtmlCompiledGames() && this.isCompiledHtmlGame(gameType));
    }

    /**
     * rerurn true if the hybrid support the "Compiled Html Game"
     */
    isCompiledHtmlGame(gameType) {
        return this._allCompiledGamesMetadata.hasOwnProperty(gameType);
    }

    /**
     * rerurn true if the hybrid support the "OnDemand Html Game"
     */
    isOnDemandHtmlGame(gameType) {

        if(this.isCompiledHtmlGame(gameType)){
            return 'true' === this._allCompiledGamesMetadata[gameType].ondemand;
        }

        return false;
    }

    navigateToOnDemandStandalone(gameType, companyName, url) {
        if (this.isOnDemandStandalone(gameType, companyName)) {
            if (this._ondemandnyxfeature && this._ondemandnyxfeature.navigate(companyName, url)) {
                return true;
            }
        }

        return false;
    }

    isOnDemandStandAloneGameRunning() {
        if (this._ondemandnyxfeature) {
            return this._ondemandnyxfeature.isOnDemandStandAloneGameRunning();
        }

        return false;
    }


    /**
     * rerurn true if the hybrid support OnDemand Standalon - Nyx is the first Standalone"
     */
    isOnDemandStandalone(gameType, companyName) {

        if (Device.hybrid.isEmbedded && this.isOnDemandHtmlGame(gameType)) {

            if (this._ondemandnyxfeature && this._ondemandnyxfeature.canHandle(companyName)) {
                return true;
            }
        }

        return false;
    }

    /**
     * save the game in cookie
     */
    saveOnDemandLoadedGame(gameType, sharedFolder) {
        if (this._ondemandfeature) {
            this._ondemandfeature.saveOnDemandLoadedGame(gameType, sharedFolder);
        }
    }

    /**
     * ask if On Demand Game already Loaded
     */
    isDisplayLoadingIndicator(gameType) {
        if (!Device.hybrid.isEmbedded) {
            return true;
        }
        return this._ondemandfeature ? this._ondemandfeature.isOnDemandLoadedGame(gameType) : true;
    }

    /**
     * rerurn true Game Meta data"
     */
    getCompiledGameMetadata(gameType) {
        if (!this.isCompiledHtmlGame(gameType)) {
            return null;
        }

        return this._allCompiledGamesMetadata[gameType];
    }


    /**
     * rerurn Game Version"
     */
    getCompiledGameVersion(gameType) {
        if (!this.isCompiledHtmlGame(gameType)) {
            return null;
        }

        return this.getCompiledGameMetadata(gameType).version;
    }


    isHybridSuportHtmlCompiledGames(){
        return 0 < this._nLocalHostPort;
    }

    getOnDemandOrigin() {
        return `http://${window.location.hostname}:${ON_DEMAND_PORT}`;
    }

    getLocalHostAndPortForOnDemand(gameUrlBuilder, pathname){
        gameUrlBuilder.protocol = 'http:';
        gameUrlBuilder.host = window.location.hostname;
        gameUrlBuilder.port = ON_DEMAND_PORT.toString();
        gameUrlBuilder.pathname = pathname;
        return gameUrlBuilder.href;
    }

    prepareGameUrl(gameType, gameUrl, pathname = '') {
        let gameUrlBuilder = new URL(gameUrl);

        if (this.isCompiledHtmlGame(gameType) && this.isOnDemandHtmlGame(gameType)) {
            // All on demand games most be served form http and not https
            return this.getLocalHostAndPortForOnDemand(gameUrlBuilder, pathname);
        }

        return gameUrlBuilder.href;
    }

    /**
     * init the Hybrid Features
     *
     * @private
     */
    _initFeatures(params) {

        const reg = require.context('../../services/hybrid/features', true, /^.*(_hybrid_feature)\.js$/);

        const loader = new Loader();
        const allFeatures = loader.getDefault(reg);

        allFeatures.forEach(feature => {
            try {
                let param = params ? params[feature.CLASS] : 'undefined';
                param = _.isString(param) ? _.safeJSON(param, '') : param;
                this.logger.info('load feature  => ' + feature.CLASS);

                const fearureInstance = feature.create(param).initFeatures(this);
                this._saveFeature(feature.CLASS, fearureInstance);
            } catch (ex) {
                this.logger.error('Failed to load feature => ', feature);
            }
        });
    }

    /**
     * save the Feature reference dynamicly
     *
     * @private
     */
    _saveFeature(className, fearureInstance) {
        let name = ('_' + className + 'Feature').toLowerCase();
        this[name] = fearureInstance;
    }



    /**
     * init the current Wrapper & functions implementation
     *
     * @private
     */
    _initWrapper() {

        this._wrapper = HybridFactory.create().getHybridWrapper();

        if (null !== this._wrapper) {
            this._wrapper.initHybridDirectCall(this);
        }

        let data = {[KEY_NAME.HYBRID_CB]: KEY_NAME.HYBRID_CB_GLOBAL_NAME};
        this.msgToHybrid(SERIVCES_FUNC_LIST.GENERAL_SET_CB, data);

        return this;
    }

    onHybridUrlScheme(name, data) {

        let feature = this._getFeature(name);

        if (feature) {
            let dataDecode = _.safeJSONandDecode(data);
            feature.onHybridDirectCall(dataDecode);
        }
    }


    /**
     *
     * @param params
     */
    onHybridDirectCall(params) {

        let objParams = _.safeJSONandDecode(params);

        let error = objParams[KEY_NAME.ERROR];
        if (error !== 0) {
            return null;
        }

        let data = objParams[KEY_NAME.DATA];


        let feature = this._getFeature(data[KEY_NAME.HYBRID_CB_FEATURE_FUNC]);//  .split('_')[0]);

        if (feature) {
            feature.onHybridDirectCall(data);
        }

        return undefined !== feature ? feature : null;
    }

    _getFeature(featureName) {
        let name = ('_' + featureName).toLowerCase();
        return this[name];
    }

    displayHybrid() {
        this._bDisplayWebView = true;
        this.onDisplayWebView();
    }

    onDisplayWebView() {

        if (this._bDisplayWebView) {

            if(this.getPushFeature() && this.getPushFeature().isEnable()) {
                this.getPushFeature().getPushActions()
                    .then(data => {
                        if(0 === data.length) {
                            if(this.getThreeDTouchFeature()) {
                                this._checkThreeDTouch();
                            }
                        }else {
                            this._displayWebView();
                            this._clearHybridDisplayTimeOut();
                        }
                    });
            } else if(this.getThreeDTouchFeature()) {
                this._checkThreeDTouch();
            }
        }
    }

    _clearHybridDisplayTimeOut() {
        if (this._webviewmanagerfeature) {
            this._webviewmanagerfeature.clearHybridDisplayTimeOut();
        }
    }

    _checkThreeDTouch(){
        this.getThreeDTouchFeature().getShortcutLaunch()
            .then(shortcut => {
                this.getThreeDTouchFeature().runAction(shortcut);
                this._displayWebView();
                this._clearHybridDisplayTimeOut();
            });
    }


    /**
     * int the hybrid.
     * return the active services.
     */
    initHybrid() {

        this.initOndemandfeature();

        this.onDisplayWebView();
        return this.msgToHybrid(SERIVCES_FUNC_LIST.GENERAL_INIT_HYBRID);
    }

    /**
     * Show the alert in native on top of webView.
     *
     * @param str - the string that will display in alert.
     * @returns {Promise}
     */
    alert(str) {
        let alertProperties = {[KEY_NAME.MSG]: str};
        return this.msgToHybrid(SERIVCES_FUNC_LIST.GENERAL_ALERT, alertProperties);
    }

    /**
     * Show the alert in native on top of webView.
     *
     * @param str - the string that will display in alert.
     * @returns {Promise}
     */
    alertd(str) {
        let alertProperties = {[KEY_NAME.MSG]: str};
        return this.msgToHybrid(SERIVCES_FUNC_LIST.GENERAL_ALERT_D, alertProperties);
    }


    setRotaion(rotation, bVal) {
        let data = {[KEY_NAME.ROTATION]: rotation, [KEY_NAME.FORCE]: bVal};
        return this.msgToHybrid(SERIVCES_FUNC_LIST.GENERAL_SET_ROTATION, data);
    }

    openMail(txt) {
        let data = {[KEY_NAME.DATA]: txt, [KEY_NAME.MAIL_TO]: 'mailto:tablet.888casino@gmail.com?&body='};
        return this.msgToHybrid(SERIVCES_FUNC_LIST.GENERAL_OPEN_MAIL, data);
    }

    openExternalLink(url) {

        let srcurl = url;
        url = this.convertToAbsoluteLink(url);

        if(Device.hybrid.isEmbedded){
            url = this.buildExternalLinkForEmbeddedHybrid(url);
        }

        if(Device.hybrid.inCasino || Device.hybrid.isEmbedded){
            url = srcurl.includes([KEY_NAME.BANK_ID] + ':///') ? srcurl : url;
            url = srcurl.includes([KEY_NAME.PHONE]) ? srcurl : url;
        }

        let data = {[KEY_NAME.DATA]: url};
        return this.msgToHybrid(SERIVCES_FUNC_LIST.GENERAL_OPEN_EXTERNAL_LINK, data);
    }

    convertToAbsoluteLink(link) {
        let absoluteLink = '';
        // check if relative or absolute link
        if (!_.isAbsoluteLink(link)) {
            absoluteLink = this.serviceFactory.windowService().getLocationOrigin();
        }
        absoluteLink += link;
        return absoluteLink;
    }

    setCbFunction(serviceFuncName, cbFuncName, privatedata) {

        let publicdata = {[KEY_NAME.HYBRID_CB_FEATURE_FUNC]: cbFuncName};

        let data = Object.assign(publicdata, privatedata);

        return this.msgToHybrid(serviceFuncName, data);
    }

    loadRemoteChill(url, ver){

        let data = {[KEY_NAME.URL]: url, [KEY_NAME.VERSION]: ver};
        return this.msgToHybrid(SERIVCES_FUNC_LIST.ON_DEMAND_LOAD_CHILL, data);
    }

    _closeGame(options) {
        return this.msgToHybrid(SERIVCES_FUNC_LIST.ON_DEMAND_CLOSE_GAME);
    }

    closeNyxODRGame() {
        return this.msgToHybrid(SERIVCES_FUNC_LIST.ON_DEMAND_NYX_CLOSE);
    }


    initOndemandfeature(){
        if(this._ondemandfeature){
            this._ondemandfeature.inidFeature();
        }
    }
    setStartOndemand(b){
        if(this._ondemandfeature){
            this._ondemandfeature.setStartOndemand(b);
        }
    }

    waitForOnDemandId(id, folderStruct = 0, sharedFolder = '') {
        this.setStartOndemand(false);
        let data = {[KEY_NAME.DATA]: id.toString(), [KEY_NAME.TIME_OUT]: 0, [KEY_NAME.FOLDER_STRUCT]: folderStruct.toString(), [KEY_NAME.FOLDER_SHARED_NAME]: sharedFolder.toString()};
        return this.msgToHybrid(SERIVCES_FUNC_LIST.ON_DEMAND_IS_READY, data);
    }

    stopProgressBarByTimeOut(){
        this.setStartOndemand(true);
        return this.msgToHybrid(SERIVCES_FUNC_LIST.ON_DEMAND_CLOSE_BY_TIME_OUT);
    }

    _onStopProgressBar() {
        this.setStartOndemand(true);
        return this.msgToHybrid(SERIVCES_FUNC_LIST.ON_DEMAND_CLOSE_BY_X);
    }

    closeByLowDiskSpace() {
        return this.msgToHybrid(SERIVCES_FUNC_LIST.ON_DEMAND_CLOSE_BY_LOW_DISK_SPACE);
    }

    deleteGameFolder(games) {
        let data = {[KEY_NAME.DATA]: games};
        return this.msgToHybrid(SERIVCES_FUNC_LIST.ON_DEMAND_DELETE_GAME_FOLDER,data);
    }

    isSupportHtmlCompiledGames() {
        return this.msgToHybrid(SERIVCES_FUNC_LIST.WEB_VIEW_IS_HTML_COMPILED_GAMES);
    }

    navigateForOnDemandNyx(url) {
        let data = {[KEY_NAME.URL]: url};
        return this.msgToHybrid(SERIVCES_FUNC_LIST.ON_DEMAND_NYX_NAVIGATE, data);
    }


    changeHeaderHeightOnDemandNyx(headerheight, dt){
        let data = {[KEY_NAME.HEADER_HEIGHT] : headerheight, [KEY_NAME.CLOSE_BY_X] : dt.enable, [KEY_NAME.CLOSE_X_POS_P] : dt.xp, [KEY_NAME.CLOSE_Y_POS_P]: dt.yp,
            [KEY_NAME.CLOSE_X_POS_L] : dt.xl, [KEY_NAME.CLOSE_Y_POS_L]: dt.yl} ;
        return this.msgToHybrid(SERIVCES_FUNC_LIST.ON_DEMAND_NYX_CHANGE_HEADER_HEIGHT, data);
    }

    IsNyxIframeSupport(){
        return this.msgToHybrid(SERIVCES_FUNC_LIST.ON_DEMAND_NYX_IS_IFRAME_SUPPORT);
    }

    GetNyxLocalHostUrl(data){
        return this.msgToHybrid(SERIVCES_FUNC_LIST.ON_DEMAND_NYX_GET_LOCAL_HOST_URL, data);
    }

    /**
     * Show the site in webview.
     *
     * @private
     */
    _displayWebView() {
        let webviewProperties = {
            [SERIVCES_PARAMS_LIST.WEB_VIEW_SPLASH]: SERIVCES_PARAMS_LIST.WEB_VIEW_SPLASH_FADE
        };
        return this.msgToHybrid(SERIVCES_FUNC_LIST.WEB_VIEW_WEB_SHOW, webviewProperties);
    }


    /* SERLAL START */
    /**
     *
     * @returns {Promise}
     */
    getSerialData() {
        return this.msgToHybrid(SERIVCES_FUNC_LIST.SERIAL_GET_SERIAL);
    }

    setSmartLinkData(smartLinkData, appflayerfeature) {
        this._appflayerfeature = appflayerfeature;
        this._strSmartLinkData = encodeURIComponent(smartLinkData);
    }

    getSmartLinkData() {
        return this._strSmartLinkData;
    }

    /* SERLAL END */


    /* 3D Touch START */
    /**
     * @param shourtcutsLaunch: parameters in json format.
     * @returns {Promise}
     * Example: "[{"action":"Login","caption":"Logintext","val":""},{"action":"QuickDeposit","caption":"QuickDeposittext","val":""}]"
     */
    init3DTouchShourtcutsLaunch(shourtcutsLaunch) {
        let data = {[KEY_NAME.DATA]: shourtcutsLaunch};
        return this.msgToHybrid(SERIVCES_FUNC_LIST.T3_D_TOUCH_INIT_SHORTCUTS, data);
    }

    /**
     * @param shortcutData:  json:
     * @param example:  {'action': 'PlayGame','caption': 'Millionaire Genie','val': '130043'}
     * @returns {Promise}
     */
    update3DTouchShortcut(shortcutData) {
        let data = {[KEY_NAME.DATA]: shortcutData};
        return this.msgToHybrid(SERIVCES_FUNC_LIST.T3_D_TOUCH_UPDATE_SHORTCUT, data);
    }

    /**
     * Delete a specific shortcut from the 3Dtouch shortcuts
     * @param action:  example: Login,QuickDeposit,PlayGame
     * @returns {Promise}
     */
    delete3DTouchShourtcut(action) {
        let data = {[KEY_NAME.DATA]: action};
        return this.msgToHybrid(SERIVCES_FUNC_LIST.T3_D_TOUCH_DELETE_SHORTCUT, data);
    }

    /**
     * delete all the shortcuts from the 3D touch Hybrid
     */
    deleteAll3DTouchShourtcuts() {
        return this.msgToHybrid(SERIVCES_FUNC_LIST.T3_D_TOUCH_DEL_ALL_SHORTCUTS);
    }

    /**
     * get the shortcut if pressed on the 3D touch
     * @returns {Promise}
     */
    get3DTouchShortcutLaunch() {
        return this.msgToHybrid(SERIVCES_FUNC_LIST.T3_D_TOUCH_GET_LAUNCH_SHORTCUT);
    }

    /* 3D Touch END */


    /*  PUSH START */


    promptPermission(){

        this.msgToHybrid(SERIVCES_FUNC_LIST.PUSH_PROMPT_PERMISSION);

        if(this.getPushFeature()){
            this.getPushFeature().promptPermission();
        }
    }

    isPushDeviceEnable() {
        return this.msgToHybrid(SERIVCES_FUNC_LIST.PUSH_IS_DEVICE_ENABLE);
    }


    /**
     * get the push action if i press on push popup
     * @returns {Promise}
     */
    getPushActions() {
        return this.msgToHybrid(SERIVCES_FUNC_LIST.PUSH_GET_ACTION);
    }

    addTag(data){
        return this.msgToHybrid(SERIVCES_FUNC_LIST.PUSH_ADD_TAG,data);
    }

    remTag(data){
        return this.msgToHybrid(SERIVCES_FUNC_LIST.PUSH_REM_TAG,data);
    }

    setAlias(data){
        return this.msgToHybrid(SERIVCES_FUNC_LIST.PUSH_SET_ALIAS,data);
    }

    /*  PUSH END */

    /* TouchID START */

    /**
     * get the token if exist for touchId
     * @returns {Promise}
     */

    setSupportedFaceId(displayAlsoFaceId){
        const data = {[KEY_NAME.DISPLAY_ALSO_FACE_ID] : displayAlsoFaceId};
        return this.msgToHybrid(SERIVCES_FUNC_LIST.TOUCH_ID_SUPPORT_FACE_ID, data);
    }

    openTouchIdSettings(){
        const data = {[KEY_NAME.DATA]: Device.os.isIOS ? OPEN_SETTINGS.TOUCH_ID_IOS : OPEN_SETTINGS.TOUCH_ID_ANDROID};
        return this.openSettings(data);
    }

    openSettings(data){
        return this.msgToHybrid(SERIVCES_FUNC_LIST.GENERAL_OPEN_SETTINGS,data);
    }

    isOpenSettingsSupported(){
        return this.msgToHybrid(SERIVCES_FUNC_LIST.TOUCH_ID_IS_OPEN_SETTINGS_SUPPORTED);
    }

    getTouchIdToken() {
        return this.msgToHybrid(SERIVCES_FUNC_LIST.TOUCH_ID_GET_TOKEN);
    }

    setToken(token) {
        const data = {[KEY_NAME.DATA]: token};
        return this.msgToHybrid(SERIVCES_FUNC_LIST.TOUCH_ID_SET_TOKEN, data);
    }

    openTouchId(caption) {
        const data = {[KEY_NAME.DATA]: caption, [KEY_NAME.KEYBORD]: 'false'};
        return this.msgToHybrid(SERIVCES_FUNC_LIST.TOUCH_ID_OPEN, data);
    }

    isTouchIdSuported() {
        return this.msgToHybrid(SERIVCES_FUNC_LIST.TOUCH_ID_IS_SUPORTED);
    }

    isOpenSettingSupported(){
        return this._touchidfeature && this._touchidfeature.isOpenSettingSupported();
    }





    isDeviceTouchEnable() {
        return new Promise((resolve) => {
            this.isTouchIdSuported().then(data => {
                if (null !== this._touchidfeature && this._touchidfeature.isFeatureEnable()) {
                    this._touchidfeature.getModel().setEnableRes(_.safeJSONandDecode(data));
                    let bEnable = this._touchidfeature.getModel().isDeviceTouchEnable() || this.isOpenSettingSupported();
                    resolve(bEnable);
                } else {
                    resolve(false);
                }
            });
        });
    }

    clearToken() {
        return this.msgToHybrid(SERIVCES_FUNC_LIST.TOUCH_ID_CLEAR_ALL);
    }

    getParamsForToken() {
        return this.msgToHybrid(SERIVCES_FUNC_LIST.TOUCH_ID_PARAMS_FOR_TOKEN);
    }

    /* TouchID END */

    /* SAFARI TEST FOR CASHIER */
    openSafariTest(url) {

        DOM.setTimeout(() => { this.testSafari(); } , 2000);

        let data = {[KEY_NAME.DATA]: url, 'top': '45' , 'bottom': '45' };
        return this.msgToHybrid(SERIVCES_FUNC_LIST.WEB_VIEW_SAFARI, data);
    }

    testSafari() {
        this.msgToHybrid(SERIVCES_FUNC_LIST.WEB_VIEW_SAFARI_PING)
            .then(() => {
                DOM.setTimeout(() => {
                    this.testSafari();
                }, 7000);
            });
    }

    openLinksAccomplished(webId, webType) {
        let data = {[KEY_NAME.WEB_ID]: webId, [KEY_NAME.TYPE]: webType };
        return this.msgToHybrid(SERIVCES_FUNC_LIST.WEB_VIEW_ACCOMPLISHED, data);
    }

    navigateWebView(data) {

        if(WEB_VIEW_IDS.DEPOSIT_WIDGET_ID === data[WEB_VIEW_INFO.ID]){
            let logger = this.serviceFactory.structuredLoggingService().getLogger();
            logger && logger.setEventType('hybrid_psp_redirect_navigate')
                .addCustomData({
                    depositWindowData: data
                });

            return this.msgToHybrid(SERIVCES_FUNC_LIST.WEB_DEPOSIT_WIDGET_NAVIFATE, data)
                .then(() => logger && logger.info())
                .catch(err => {
                    logger && logger.addCustomData({
                        errorDetails: err
                    }).error();

                    throw err;
                });
        }else {
            return this.msgToHybrid(SERIVCES_FUNC_LIST.WEB_SECOND_NAVIFATE, data);
        }
    }

    checkHybridSupportDepositWidget(data){
        return this.msgToHybrid(SERIVCES_FUNC_LIST.WEB_DEPOSIT_WIDGET_SUPPORTED, data);
    }


    showWebView(data) {
        return this.msgToHybrid(SERIVCES_FUNC_LIST.WEB_SECOND_SHOW, data);
    }

    getDpToPx(){
        return this.msgToHybrid(SERIVCES_FUNC_LIST.WEB_VIEW_GET_DP_2_PX);
    }

    updateScreenSize(data){
        return this.msgToHybrid(SERIVCES_FUNC_LIST.WEB_SECOND_UPDATE_SIZE, data);
    }

    closeWebView(data) {
        return this.msgToHybrid(SERIVCES_FUNC_LIST.WEB_SECOND_CLOSE, data);
    }

    isWebviewmanagerfeature() {

        if (!Device.hybrid.inCasino) {
            return false;
        }

        return null !== this._webviewmanagerfeature;
    }

    isNativeSupportSecondWebView() {
        return this.isWebviewmanagerfeature() ? this._webviewmanagerfeature.isNativeSupportSecondWebView() : false;
    }

    isNativeSupportSafariCashier() {
        return this.isWebviewmanagerfeature() ? this._webviewmanagerfeature.isNativeSupportSafariCashier() : false;
    }

    getParamsForCasheir() {
        return this.isWebviewmanagerfeature() ? this._webviewmanagerfeature.getParamsForCasheir() : '';
    }

    getUrlSchemeToOpen() {
        return this.isWebviewmanagerfeature() ? this._webviewmanagerfeature.getUrlSchemeToOpen() : '';
    }

    openCasheir(url) {
        if (this.isNativeSupportSafariCashier()) {
            this._webviewmanagerfeature.openCasheir(url);
            return true;
        }
        return false;
    }


    /* WEB VIEW MANAGER END */


    /* INFO START */


    getInfoFeature() {
        return this._hybridinfofeature;
    }

    getUrlScheme() {
        let infoFeature = this.getInfoFeature();
        let urlScheme = undefined !== infoFeature ? infoFeature.getUrlScheme() : '';
        return urlScheme;
    }

    setUrl(url, reload) {
        let data = {[KEY_NAME.URL]: url, [KEY_NAME.RELOAD]: reload};
        return this.msgToHybrid(SERIVCES_FUNC_LIST.INFO_SET_URL, data);
    }

    getInfoForDisplay() {
        let infoFeature = this.getInfoFeature();
        let info = undefined !== infoFeature ? infoFeature.getInfoForDisplay() : '';
        return info;
    }

    getInfo(key) {
        let data = {[KEY_NAME.DATA]: key};
        return this.msgToHybrid(SERIVCES_FUNC_LIST.INFO_GET_ALL_INFO, data);
    }


    isDebugMode() {
        let infoFeature = this.getInfoFeature();
        return null !== infoFeature ? infoFeature.isDebugMode() : false;
    }

    getVersion() {
        let infoFeature = this.getInfoFeature();
        return null !== infoFeature ? infoFeature.getVersion() : 0;
    }

    getAppleID() {
        let infoFeature = this.getInfoFeature();
        return null !== infoFeature ? infoFeature.getAppleID() : '';
    }

    /* INFO END*/

    /* URL_SCHEME START */


    getInfoUrlScheme() {
        return this.msgToHybrid(SERIVCES_FUNC_LIST.URL_SCHEME_GET_URL_SCHEME);
    }

    clearUrlScheme() {
        return this.msgToHybrid(SERIVCES_FUNC_LIST.URL_SCHEME_CLEAR);
    }

    /* URL_SCHEME END */

    /* FABRIC */

    createFabricEv(name){
        if(null != this._fabricfeature) {
            this._fabricfeature.createEvName(name);
        }
    }

    addFabricKeyVal(key, val){
        if(null != this._fabricfeature) {
            return this._fabricfeature.addEvKeyVal(key, val);
        }else {
            return null;
        }
    }

    getEv() {
        return null != this._fabricfeature ? this._model.getEv() : null;
    }

    addFabricEvent(ev) {
        return this.msgToHybrid(SERIVCES_FUNC_LIST.FABRIC_ADD_EVENT,ev);
    }

    /* FABRIC */


    /* GEO */

    isPermissionPopupSupported(){
        return this.msgToHybrid(SERIVCES_FUNC_LIST.GEO_IS_PERMISSION_SUPPORTED);
    }

    getGeoLocation(data){
        return this.msgToHybrid(SERIVCES_FUNC_LIST.GEO_GET_LOCATION,data);
    }

    showGeoLocationPermissionPopUp(){
        return this.msgToHybrid(SERIVCES_FUNC_LIST.GEO_SHOW_PERMISSION);
    }

    /* GEO */


    /* LEXIS NEXIS */

    IsLexisNexisSupported(){
        return this.msgToHybrid(SERIVCES_FUNC_LIST.LEXIS_NEXIS_IS_SUPPORTED);
    }

    getLexisNexisInfo(data){
        return this.msgToHybrid(SERIVCES_FUNC_LIST.LEXIS_NEXIS_GET_INFO, data);
    }

    getLexisNexisSession(marketingData){

        if (null !== this._lexisnexisfeature) {
            return this._lexisnexisfeature.getLexisNexisInfo(marketingData, false);
        }

        return new Promise((resolve) => {
            resolve(marketingData);
        });
    }

    /* LEXIS NEXIS *



    /* DEPOSIT WIDGET */

    updateDepositWidgetSupported() {
        if (null !== this._webviewmanagerfeature) {
            this._webviewmanagerfeature.setDepositWidgetSupported();
        }
    }

    isDepositWidgetSupported(){
        if(!Device.hybrid.inCasino) {
            return true; // if is not hybrid then we let other layers decide if the user is eligible for deposit widget.
        }
        if (null !== this._depositwidgetfeature) {
            return this._depositwidgetfeature.isDepositWidgetSupported();
        }

        return false;
    }

    /* DEPOSIT WIDGET */


    /* LOBBY POP UP */

    isPopUpAboveSecounpSupported(){
        return this.msgToHybrid(SERIVCES_FUNC_LIST.LOBBY_POPUP_IS_SUPPORTED);
    }

    popUpAboveSecoundShow(data){
        return this.msgToHybrid(SERIVCES_FUNC_LIST.LOBBY_POPUP_SHOW,data);
    }

    popUpAboveSecoundClose(){
        return this.msgToHybrid(SERIVCES_FUNC_LIST.LOBBY_POPUP_CLOSE);
    }

    displayRatingPopup(){
        return this.msgToHybrid(SERIVCES_FUNC_LIST.RATE_APP);
    }

    /* FIRE BASE */

    getFireBaseData() {
        return this.msgToHybrid(SERIVCES_FUNC_LIST.FIRE_BASE_GET_DATA);
    }

    getAppMareketingData(){
        const appsFlayerData = this._appflayerfeature ? this._appflayerfeature.getAppMareketingData() : {};
        const fireBaseData = this._firebasefeature ? this._firebasefeature.getAppMareketingData() : {};

        const allData = Object.assign(appsFlayerData, fireBaseData);

        return allData;
    }

    /**
     * Entry point to send calls for hybrid & back.
     *
     * @param serviceFuncName: the service name + function name for exp: WebView_Webshow:
     * WebView - service name.
     * WebShow - function name.
     * @param jsonParams: parameters in json format.
     * @returns {Promise}
     */
    msgToHybrid(serviceFuncName, jsonParams = {}) {
        if (this.isNotHybridConnection()) {
            if(serviceFuncName === SERIVCES_FUNC_LIST.WEB_DEPOSIT_WIDGET_NAVIFATE) {
                let logger = this.serviceFactory.structuredLoggingService().getLogger();
                logger && logger.setEventType('hybrid_psp_redirect_not_hybrid_connection')
                    .addCustomData({
                        depositWindowData: jsonParams,
                        wrapperIsNull: this._wrapper ? 'No' : 'Yes'
                    })
                    .error();
            }

            this.logger.info([
                'Hybrid Call:',
                'Method: ' + serviceFuncName,
                'Params: ' + JSON.stringify(jsonParams)
            ]);

            return Promise.resolve();
        }
        return this._wrapper.msgToHybrid(serviceFuncName, jsonParams);
    }

    /**
     * @Description we need connection in those hybrids
     */
    isNotHybridConnection() {
        return (!Device.hybrid.isHybrid) || null === this._wrapper;
    }

    // Event.fire(SYSTEM_EVENTS.HYBRID_ALERT, str);

    /***
     * @Description If the Url is  with localhost or just relative we need to add the cmsSource
     * @Note BUG 1322249
     * @param url
     */
    buildExternalLinkForEmbeddedHybrid(url){

        let cmsSource = this.serviceFactory.integrationService().getCmsSourceIfValid();
        if(cmsSource) {
            //If we got localhost link
            if (_.isString(url) && (url.startsWith('http://localhost') || url.startsWith('https://localhost'))) {
                //Remove the localhost (it will not work on embedded Hybrid) and add the cmsSource to the relative link
                url = _.removeLocalhost(url);
                return cmsSource + "/" + url;
            }

            //If we got localhost in the domain
            let strReplace = this.getReplaceLocalhost(url, cmsSource);

            if (strReplace.length > 0) {
                return strReplace;
            }

            //If we got relative link(and not mailto link) - add the cms source
            if (!_.isAbsoluteLink(url) && !_.isNullOrUndefined(url) && !url.startsWith('mailto:')) {
                return cmsSource + url;
            }

        }
        return url;
    }

    getReplaceLocalhost(url, cmsSource) {
        let strReplace = '';
        if (_.isString(url) && url.includes('reason') && url.includes('domain')) {
            if (url.includes([LOCAL_HOST.HTTP])) {
                strReplace = [LOCAL_HOST.HTTP];
            } else if (url.includes([LOCAL_HOST.HTTPS])) {
                strReplace = [LOCAL_HOST.HTTPS];
            }

            if (strReplace.length > 0) {
                strReplace = url.replace(strReplace, cmsSource);
            }
        }
        return strReplace;
    }

    /**
     * @description When it is internal link we need to redirect to the Hybrid localhost and not to the fullurl
     * @param url
     */
    getRedirectInternalPageUrl(url){
        try {
            let redirectFullURL = new URL(url)
            redirectFullURL.protocol = this.serviceFactory.windowService().getProtocol();
            redirectFullURL.host = this.serviceFactory.windowService().getHost();

            return redirectFullURL.href;
        }catch (e){
            this.logger.error('Failed to  getRedirectInternalPageUrl error: ' + e + ' ,return original url: ' + url);
            return url;
        }

    }

    openPopUpOnSecondWebView(content,timeout) {

        if(!Device.hybrid.isEmbedded) {
            return;
        }

        const dataforHybrid = {
            content: content,
            isFirstShow: true,
            showHybridPopUp: true,
            timeout:timeout
        };

        setTimeout(() => {//the popup is not ready yet
            Event.fire(SYSTEM_EVENTS.SHOW_POPUP_ABOVE_HYBRID_SECOND_WEB_VIEW, dataforHybrid);
        }, 1000);
    }

    closePopUpOnSecondWebView() {
        if(Device.hybrid.isEmbedded) {
            Event.fire(SYSTEM_EVENTS.CLOSE_POPUP_ABOVE_HYBRID_SECOND_WEB_VIEW);
        }
    }

    executeWaitForHybridGameStep({folderStruct, sharedFolder, gameType, vendorName, companyName}) {
        const gameStepLogicHandler = WaitForHybridGameStepLogicHandler.create({
            serviceFactory: this.serviceFactory,
            folderStruct,
            sharedFolder,
            gameType,
            vendorName,
            companyName
        })

        return gameStepLogicHandler.run();
    }
}
export default HybridService;